module.exports = __webpack_public_path__ + "img/magnifier.9df28d04.svg";